<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Klankbord plus | klankvoeten" [steps]="assignments().length" [progress]="index()" />

  <rid-mechanic-content>
    @if (titleKey() === 'SPEAK') {
      <rid-mechanic-title [title]="'Spreek de klankvoeten van het woord uit'" />
    }
    @if (titleKey() === 'ASSESS') {
      <rid-mechanic-title [title]="'Dit is het juiste antwoord!'" />
    }

    @for (a of [assignment()]; track a) {
      <div
        class="absolute grid h-[34rem] w-full transition-[grid-template-rows] duration-500 ease-in-out"
        [style.grid-template-rows]="phase() === 'SPLIT' ? '0.4fr 0.6fr' : '1fr 0fr'"
        animate.leave="anim-fade-out"
      >
        <div class="relative grid place-items-center">
          <div class="relative size-64">
            <rid-audio-button
              #audioButton
              [src]="audioSrc()"
              size="LARGE"
              animate.enter="wait-500 anim-pop-in"
              ridSfx="BUBBLE_POP"
              (animationend)="$event.animationName === 'pop-in' ? speak() : undefined"
            />
          </div>
        </div>

        <div class="relative w-full">
          @if (phase() === 'SPLIT') {
            <div class="absolute inset-x-0 top-0 grid justify-items-center gap-6 pt-2" animate.enter="wait-300 anim-fade-in">
              <rid-text-input>
                <div class="flex gap-2 p-2">
                  @for (slot of splitAnswers(); track $index) {
                    <div class="grid size-16 place-items-center">
                      @if (slot === '>') {
                        <i-klankvoet-normal
                          class="size-14 text-emerald-500 transition-transform duration-300"
                          [class.scale-125]="highlightIndex() === $index"
                          animate.enter="anim-pop-in"
                        />
                      } @else if (slot === '<') {
                        <i-klankvoet-stom
                          class="size-14 text-rose-500 transition-transform duration-300"
                          [class.scale-125]="highlightIndex() === $index"
                          animate.enter="anim-pop-in"
                        />
                      } @else {
                        <div class="h-12 w-8 rounded-md bg-slate-200"></div>
                      }
                    </div>
                  }
                </div>
              </rid-text-input>

              <div class="flex gap-4 rounded-md border-2 border-slate-300 bg-white p-4">
                <button
                  class="grid size-16 cursor-pointer place-items-center rounded-md hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-40"
                  [disabled]="isEvaluating() || isWordComplete()"
                  (click)="selectKlankvoet('>')"
                >
                  <i-klankvoet-normal class="size-14 text-emerald-500" />
                </button>
                <button
                  class="grid size-16 cursor-pointer place-items-center rounded-md hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-40"
                  [disabled]="isEvaluating() || isWordComplete()"
                  (click)="selectKlankvoet('<')"
                >
                  <i-klankvoet-stom class="size-14 text-rose-500" />
                </button>
              </div>
            </div>
          }
        </div>
      </div>
    }

    @if (phase() === 'SPEAK' && canReveal()) {
      <rid-bottom-button content="Klaar!" (clicked)="reveal()" />
    }

    @if (phase() === 'ASSESS' && showAnswer()) {
      <rid-assessment-toast (assessed)="assess($event)" />
    }

    <!-- explanation dialog -->
    @if (showExplanation()) {
      <rid-modal-background [blur]="true" />
      <rid-klankvoet-rule-modal ridSfx="HINT" [rule]="assignment().rule" (continue)="closeExplanation()" />
    }

    <!-- feedback overlay -->
    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
